import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { StaticDocument } from '@inyova/models';

import { DocType, NewDocType } from '@shared/models/Profile';
import { DOCUMENT_TYPE_ID } from 'src/app/app.constants';

@Component({
  selector: 'app-verification-documents',
  templateUrl: './verification-documents.component.html',
  styleUrls: ['./verification-documents.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class VerificationDocumentsComponent implements OnChanges {
  @Input() haveError: boolean;
  @Input() saxoWorking: boolean;
  @Input() isLoading: boolean;
  @Input() documents: DocType[] = [];
  @Input() staticDocs: { docs: StaticDocument[]; initialized: boolean };
  @Input() appLocation: string;
  @Input() timeLeft: number;
  @Output() downloadStaticDocs: EventEmitter<StaticDocument> = new EventEmitter<StaticDocument>();
  @Output() downloadDocs: EventEmitter<DocType | NewDocType> = new EventEmitter<DocType | NewDocType>();
  passMinute = false;
  dividedByThree: number;
  oneMinuteCountDown: number;
  DOCUMENT_TYPE_ID = DOCUMENT_TYPE_ID;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.documents) {
      this.documents = changes.documents.currentValue;
    }

    if (changes.timeLeft) {
      // for initial value
      if (!changes.timeLeft.previousValue) {
        this.dividedByThree = Math.floor(changes.timeLeft.currentValue / 3);
      }
      this.oneMinuteCountDown = changes.timeLeft.currentValue - this.dividedByThree * 2;
      if (this.oneMinuteCountDown <= 0) {
        this.passMinute = true;
      }
    }
  }

  onDownloadDocs(doc: DocType | NewDocType): void {
    this.downloadDocs.emit(doc);
  }

  onDownloadStaticDocs(doc: StaticDocument) {
    this.downloadStaticDocs.emit(doc);
  }
}
